import { useLanguage } from '../../../../../../_CORE/Contexts/Translate/useLanguageContext';
import { FaGlobeAmericas } from 'react-icons/fa';
import { ES, GB, BR, FR, IT, DE } from 'country-flag-icons/react/3x2';
import { useHeaderUtilities } from '../_Hooks/useHeaderUtilities';
import { UtilityDropdown, UtilityItem } from '../UtilityDropdown';

/*
    🔥 BANDERA POR IDIOMA

    ⚠️ UN IDIOMA NO ES UN PAIS. Por eso hace falta el mapa: "en" no tiene
       bandera propia, se le asigna la de Reino Unido; "pt" va con Brasil
       porque es el uso mas comun en la region. Son decisiones, no datos.

    ⚠️ SE IMPORTAN LAS BANDERAS UNA POR UNA A PROPOSITO.

       country-flag-icons trae ~250 paises. Con
       import * as FLAGS se cae el tree-shaking y entran los 250 al
       bundle para usar dos. Para sumar un idioma: agregas el pais al
       import de arriba y una linea aca.

    ⚠️ Si el contexto de idioma esta conectado, cada lang ya viene con su
       propia Flag (mira LANG_META en useLanguageContext). Esa gana: este
       mapa es el respaldo para cuando el selector corre suelto con la
       lista de layout navigation, que solo tiene code y label.
*/
const LANG_FLAG = { es: ES, en: GB, pt: BR, fr: FR, it: IT, de: DE };

const onResolveFlag = (lang) => lang?.Flag ?? LANG_FLAG[lang?.code] ?? null;

/*
    ⚠️ LA FUENTE ES ThemeAppContext... perdón, LanguageProvider

       Antes este componente guardaba el idioma escribiendo lang en el <html> y
       solo avisaba al contexto si el layout le pasaba onChangeLanguage. Los
       layouts nunca lo pasaron: mandaban languages y nada mas. Resultado:
       elegias English, se marcaba, y no se traducia nada porque el contexto
       jamas se enteraba.

       Ahora la lista, el marcado y el cambio salen todos del contexto.

    ⚠️ LAS PROPS SIGUEN GANANDO

       Si alguien pasa current / onChangeLanguage desde afuera, mandan esos.
       El contexto queda de respaldo.
*/
export const Language = ({ languages = null, current = null, onChangeLanguage = null }) => {

    const { useDataLanguage, call_toggleTranslate } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.header ?? {};

    const { onClose } = useHeaderUtilities();

    const LANGUAGES = languages?.length ? languages : (useDataLanguage.availableLangsMeta ?? []);

    const CURRENT = current ?? useDataLanguage.currentLang;

    const onSelect = (code) => {
        onClose();
        if (onChangeLanguage) return onChangeLanguage(code);
        call_toggleTranslate(code);
    };

    /*
        ⚠️ EL DISPARADOR MUESTRA LA BANDERA DEL IDIOMA ACTIVO

           El planeta no informa nada: hay que abrir el menu para saber en que
           idioma estas. La bandera lo dice de un vistazo.

           Si el codigo activo no tiene bandera -porque vino de una lista suelta
           sin Flag y no esta en LANG_FLAG- vuelve el planeta. Un hueco donde
           deberia haber un icono se lee como un error de carga.
    */
    const ACTIVE = LANGUAGES.find((lang) => lang.code === CURRENT);

    const ActiveFlag = onResolveFlag(ACTIVE);

    const ICON = ActiveFlag
        ? <ActiveFlag className="LStudio__app_utility__flag_trigger" />
        : <FaGlobeAmericas size={18} />;

    return (
        <UtilityDropdown id="language" label={TEXT.language} width={220} icon={ICON}>
            {
                LANGUAGES.map((lang) => {

                    const Flag = onResolveFlag(lang);

                    return (
                        <UtilityItem key={lang.code} title={lang.label}
                            icon={Flag ? <Flag className="LStudio__app_utility__flag" /> : null}
                            isSelected={lang.code === CURRENT}
                            onClick={() => onSelect(lang.code)} />
                    );
                })
            }
        </UtilityDropdown>
    );
};